<template></template>
<script>

    export default {
        name: 'Settings',
        data () {
        return {
        
        // componentKey: 0,
        }
    },

    methods: {
    mountid: (function() { //always remove the $ in function($)
    'use strict';
    })
    },

    created: function(){
        //use load event to load all extended javascripts
       window.addEventListener('load', this.mountid);
    },
    destroyed () {
        //destroy the load event to load all extended javascripts
        window.removeEventListener('load', this.mountid);
    }
    }
</script>




// WEBPACK FOOTER //
// settings.vue?0f177cc5